import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPause$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPause extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '184afea3732f1b8a8b7a2f53b8d056982e7c5cc5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '79e3eb611e62c787b558f9e63247bc302075c325', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ecddb1c78ebbffb37774a58837ef674f737eee33', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm8 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-pause", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-pause"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-pause":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPause$1);
            }
            break;
    } });
}

const CosmosIconPause = CosmosIconPause$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPause, defineCustomElement };
